<template>
    <div ref="panel" class="fixed inset-0 z-50 flex" tabindex="0" @keydown.esc="close()">
        <!-- Backdrop -->
        <transition enter-class="opacity-0" leave-to-class="opacity-0">
            <div
                v-if="ready"
                class="absolute inset-0 bg-black/40 transition-opacity duration-200"
                @click.prevent="close"
            ></div>
        </transition>

        <!-- Panel -->
        <transition
            enter-class="translate-x-full md:translate-x-full"
            enter-active-class="transition-transform duration-200"
            leave-to-class="translate-x-full md:translate-x-full"
            leave-active-class="transition-transform duration-200"
        >
            <form
                v-show="ready"
                class="relative ml-auto flex h-full w-full flex-col bg-white shadow-xl md:w-[480px]"
                @submit.prevent="$emit('submit')"
            >
                <!-- Header -->
                <div
                    class="flex flex-shrink-0 items-center justify-between border-b border-neutral-lighter px-5 py-4"
                >
                    <slot name="header" />
                    <button
                        type="button"
                        class="ml-4 rounded-lg p-1.5 text-neutral-darker transition-colors hover:bg-neutral-lightest hover:text-neutral-darkest"
                        @click.prevent="close"
                    >
                        <Icon :icon="['far', 'xmark']" class="text-lg" />
                    </button>
                </div>

                <!-- Scrollable content -->
                <div class="flex-1 overflow-y-auto px-5 py-4">
                    <slot />
                </div>

                <!-- Footer -->
                <div class="flex-shrink-0 border-t border-neutral-lighter bg-white px-5 py-4">
                    <slot name="footer" />
                </div>
            </form>
        </transition>

        <a tabindex="0" class="fixed top-0 overflow-hidden" @focus="$refs.panel.focus()" />
    </div>
</template>

<script>
import { Vue, Component } from 'vue-property-decorator';
import { HELPERS_SLEEP } from '@/constants';

@Component
export default class SlideOver extends Vue {
    ready = false;

    mounted() {
        this.ready = true;
        this.$refs.panel.focus();
    }

    created() {
        const unregisterRouterGuard = this.$router.beforeEach((_, __, next) => {
            this.close();
            next();
        });

        this.$once('hook:destroyed', () => {
            unregisterRouterGuard();
        });
    }

    async close() {
        this.ready = false;
        await this.$store.dispatch(HELPERS_SLEEP, 250);
        this.$emit('close');
    }
}
</script>
